import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectTotalUnreadInboxCount } from "../redux/selectors";

const BASE_TITLE = "Clusterden";

// Badging API — shows the unread count on the OS taskbar/dock icon when the app is
// installed as a standalone PWA (manifest.json already has display: "standalone" +
// icons, so no install-side changes are needed). Chromium-only (Chrome/Edge) today;
// unsupported browsers (Firefox, Safari) just don't have the method, so this is a no-op
// there rather than an error.
const setAppBadgeCount = (count) => {
  if (!("setAppBadge" in navigator)) return;
  if (count > 0) {
    navigator.setAppBadge(count).catch(() => {});
  } else {
    navigator.clearAppBadge().catch(() => {});
  }
};

/**
 * WhatsApp-style unread indicator: prefixes the document title with the current
 * workspace's unread count and mirrors it onto the taskbar/dock icon via the Badging
 * API. Mounted once at the app root (see App.js) — the count comes from
 * inboxRecentSlice, which already only ever holds the currently open workspace's
 * data, so this is naturally scoped per-workspace with no extra fetching.
 */
export function useUnreadTabBadge() {
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
  const unreadCount = useSelector(selectTotalUnreadInboxCount);

  useEffect(() => {
    const count = isAuthenticated ? unreadCount : 0;
    document.title = count > 0 ? `(${count}) ${BASE_TITLE}` : BASE_TITLE;
    setAppBadgeCount(count);
  }, [isAuthenticated, unreadCount]);
}
